
import * as React from "react";
import { cn } from "@/lib/utils";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

interface StandardTextFieldProps {
  id: string;
  label: string;
  icon?: React.ReactNode;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: string;
  required?: boolean;
  className?: string;
  disabled?: boolean;
}

export function StandardTextField({
  id,
  label,
  icon,
  value,
  onChange,
  placeholder,
  type = "text",
  required = false,
  className,
  disabled = false,
}: StandardTextFieldProps) {
  return (
    <div className="space-y-2">
      <Label 
        htmlFor={id} 
        className="text-sm font-medium text-foreground/80 flex items-center"
      >
        {icon && <span className="mr-1">{icon}</span>}
        {label}{required && <span className="text-red-500 ml-1">*</span>}
      </Label>
      
      <Input
        id={id}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className={cn(
          "w-full bg-white/30 dark:bg-white/10 backdrop-blur-sm border border-accent/20",
          "focus:border-accent/40 focus-visible:border-accent/40 transition-all duration-300",
          "hover:border-accent/30 hover:shadow-md", 
          "placeholder:text-gray-400 hover:placeholder:text-gray-200",
          className
        )}
      />
    </div>
  );
}
